module.exports = __webpack_public_path__ + "static/background1-35e74e22064c0d8f527ea65458233fed.svg";